module.exports = __webpack_public_path__ + "static/media/amano.d18b8f92.jpg";